<template>
<v-data-table :headers="headers" :items="filteredItems" :search="search">
    <template v-slot:items="{ item }">
        <td>{{ item.Name }}</td>        
        <td>{{ item.IsActive ? 'Active' : 'Inactive' }}</td>
        <td>
            <v-btn color="primary" block @click="$emit('edit', item)">
                <span>Edit</span>
            </v-btn>
        </td>
    </template>
</v-data-table>
</template>

<script>
export default {
    props: {
        filteredItems: {
            type: Array,
            required: true
        },
        search: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            headers: [
                {
                    text: "Name",
                    value: "Name",
                    sortable: true
                },
                {
                    text: "Active Status",
                    value: "IsActive",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "PestClassificationID",
                    sortable: false
                }
            ]
        }
    }
}
</script>
